/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  ThreeSixtyEmployeeGroupResultDto,
  ThreeSixtyEmployeeGroupDto,
  ThreeSixtyEmployeeGroupBulkRequestDto,
} from './models';

/**
 * ThreeSixtyEmployeeGroupApi - API class
 */
export class ThreeSixtyEmployeeGroupApi extends LinqService {

  /**
   * Creates a new ThreeSixtyEmployeeGroupApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: ThreeSixtyEmployeeGroupDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param bulkRequestDto 
   */
  addOrUpdateBulk(bulkRequestDto?: ThreeSixtyEmployeeGroupBulkRequestDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/AddOrUpdateBulk`;
    let query = this.createQuery<ThreeSixtyEmployeeGroupResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = bulkRequestDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/GetAsync`;
    let query = this.createQuery<ThreeSixtyEmployeeGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/GetTranslatedAsync`;
    let query = this.createQuery<ThreeSixtyEmployeeGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/List`;
    let query = this.createQuery<ThreeSixtyEmployeeGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/ListTranslated`;
    let query = this.createQuery<ThreeSixtyEmployeeGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param bulkRequestDto 
   */
  removeThreeSixtyEmployeeGroupsBulk(bulkRequestDto?: ThreeSixtyEmployeeGroupBulkRequestDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/RemoveThreeSixtyEmployeeGroupsBulk`;
    let query = this.createQuery<ThreeSixtyEmployeeGroupResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = bulkRequestDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: ThreeSixtyEmployeeGroupDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEmployeeGroup/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
